<template>
  <div class="miniprogram-box common-style">
    <div class="miniprogram-box__header common-style"></div>
    <div class="miniprogram-box__content1 common-style"></div>
    <div class="miniprogram-box__content2 common-style"></div>
    <div class="miniprogram-box__content3 common-style"></div>
    <div class="miniprogram-box__content4 common-style"></div>
    <div class="miniprogram-box__content5 common-style"></div>
    <div class="miniprogram-box__content6 common-style"></div>
    <div class="miniprogram-box__content7 common-style"></div>
    <div class="miniprogram-box__content8 common-style"></div>
    <div class="miniprogram-box__content9 common-style"></div>
    <div class="miniprogram-box__content10 common-style"></div>
    <div class="miniprogram-box__content11 common-style"></div>
    <div class="miniprogram-box__content12 common-style"></div>
    <div class="footer">
        <c-button class="footer__btn" @click.native="downLoadApp()">
          立即开通
        </c-button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default {
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      downLoadApp () {
        window.location.href = 'http://i200.cn/Download.aspx?from=newmobilepage2017'
      }
    },
    computed: {
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?3b01ede6